import Icon from "@expo/vector-icons/MaterialCommunityIcons";
import type { UnifiedCitation } from "@memorang/types";
import { Image } from "react-native";
import { TouchableOpacity } from "react-native";
import { Dialog, Text } from "react-native-paper";
import { Divider } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import Box from "../Box";
import DialogWrapper from "../DialogWrapper";
import ScrollContainer from "../ScrollContainer";

export type SourceListProps = {
	sources: UnifiedCitation[];
	showDivider?: boolean;
	visible: boolean;
	onClose: () => void;
	onPress: (source: UnifiedCitation) => void;
};

const SourceList = ({
	sources,
	onClose,
	showDivider = true,
	visible,
	onPress,
}: SourceListProps) => {
	const theme = useAppTheme();

	const content = (
		<Box>
			{sources.map((source, index) => (
				<TouchableOpacity key={source.title} onPress={() => onPress(source)}>
					<Box>
						<Box
							flexDirection="row"
							gap={16}
							key={source.title}
							paddingVertical={16}
						>
							<Box gap={8} flex={1}>
								<Box
									flexDirection="row"
									gap={8}
									alignSelf="flex-start"
									alignItems="center"
								>
									<Box
										borderRadius={33}
										justifyContent="center"
										alignItems="center"
									>
										{source.thumbnailUri ? (
											<Image
												source={{ uri: source.thumbnailUri }}
												style={{ width: 28, height: 28, borderRadius: 33 }}
											/>
										) : (
											<>
												{source.url ? (
													<Icon
														name="web"
														size={28}
														color={theme.colors.onSurfaceVariant}
													/>
												) : (
													<Icon
														name="book-open-page-variant-outline"
														size={28}
														color={theme.colors.onSurfaceVariant}
													/>
												)}
											</>
										)}
									</Box>

									<Box flex={1}>
										<Text
											variant="bodyMedium"
											style={{ color: theme.colors.onSurface }}
										>
											{source.title}
										</Text>
										<Text
											variant="labelMedium"
											style={{ color: theme.colors.onSurfaceVariant }}
											numberOfLines={1}
										>
											{source.url ? source.url : `Page ${source.page}`}
										</Text>
									</Box>
								</Box>
								<Box gap={8}>
									<Text
										variant="bodyLarge"
										numberOfLines={2}
										style={{ color: theme.colors.onSurface }}
									>
										{source.pageContent}
									</Text>
									{/* <Text
										variant="bodyMedium"
										numberOfLines={3}
										style={{ color: theme.colors.onSurfaceVariant }}
									>
										{source.description}
									</Text> */}
								</Box>
							</Box>
							{source.thumbnailUri && (
								<Box justifyContent="flex-end">
									<Image
										source={{ uri: source.thumbnailUri }}
										style={{ width: 84, height: 84, borderRadius: 12 }}
									/>
								</Box>
							)}
						</Box>
						{index !== sources.length - 1 && showDivider && (
							<Box paddingHorizontal={16}>
								<Divider />
							</Box>
						)}
					</Box>
				</TouchableOpacity>
			))}
		</Box>
	);

	return (
		<DialogWrapper visible={visible} handleClose={onClose}>
			<Dialog.Title>Sources</Dialog.Title>
			<ScrollContainer>
				<Dialog.Content>{content}</Dialog.Content>
			</ScrollContainer>
		</DialogWrapper>
	);
};

export default SourceList;
